import { render, staticRenderFns } from "./WaitReward.vue?vue&type=template&id=21ef5b34&scoped=true&"
import script from "./WaitReward.vue?vue&type=script&lang=js&"
export * from "./WaitReward.vue?vue&type=script&lang=js&"
import style0 from "./WaitReward.vue?vue&type=style&index=0&id=21ef5b34&lang=scss&scoped=true&"
import style1 from "./WaitReward.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ef5b34",
  null
  
)

export default component.exports